export enum CaseStatus {
    REGISTERED = '86e5f8fa-086c-ed11-9560-000d3a69756c',
    REGISTERED_NO = '131eb9a7-6c8c-ed11-81ad-000d3adf6077',
    REGISTERED_FI = '11adbfcd-bb51-f011-877b-000d3ab2abfa',

    ONGOING = '4145226f-6cb0-ed11-83ff-000d3adf60bc',
    ONGOING_NO = 'bade18be-6c8c-ed11-81ad-000d3adf6077',
    ONGOING_FI = '13adbfcd-bb51-f011-877b-000d3ab2abfa',

    EXECUTED = '5594d35e-096c-ed11-9560-000d3a69756c',
    EXECUTED_NO = '611e01b3-6c8c-ed11-81ad-000d3adf6077',
    EXECUTED_FI = '777246c4-da87-f011-b4cb-7ced8d76ba58',

    COMPLETED = '4869e164-096c-ed11-9560-000d3a69756c',
    COMPLETED_NO = 'bdc52df2-6c8c-ed11-81ad-000d3adf6077',
    COMPLETED_FI = '797246c4-da87-f011-b4cb-7ced8d76ba58',

    BOOKED = "67a385a0-896d-ee11-9ae7-000d3adf68d5",
    BOOKED_FI = '7d7246c4-da87-f011-b4cb-7ced8d76ba58',

    NOT_RESPONDING = '6c4f2e0d-096c-ed11-9560-000d3a69756c',
    NOT_RESPONDING_FI = '15adbfcd-bb51-f011-877b-000d3ab2abfa', // Ilmoittaja ei vastaa

    WAITING_ON_WEATHER = '9a598a19-096c-ed11-9560-000d3a69756c',
    WAITING_ON_WEATHER_FI = '717246c4-da87-f011-b4cb-7ced8d76ba58', // Odottaa oikeita sääolosuhteita

    WAITING_ON_DECISION = 'ea4e1126-096c-ed11-9560-000d3a69756c',
    WAITING_ON_DECISION_FI = '19adbfcd-bb51-f011-877b-000d3ab2abfa',  //Odottaa päätöstä

    WAITING_ON_SUBCONTRACTOR = '85938732-096c-ed11-9560-000d3a69756c',
    WAITING_ON_SUBCONTRACTOR_FI = '1badbfcd-bb51-f011-877b-000d3ab2abfa', // Odottaa aliurakoitsijaa
    WAITING_ON_SUBCONTRACTOR_NO_PORTAL = '737246c4-da87-f011-b4cb-7ced8d76ba58', // Odottaa aliurakoitsijaa (Ei portaali)


    WAITING_ON_MATERIAL = '2a76fb3e-096c-ed11-9560-000d3a69756c',
    WAITING_ON_MATERIAL_FI = '1dadbfcd-bb51-f011-877b-000d3ab2abfa', // Odottaa materiaalia

    WAITING_ON_INVESTIGATION = 'b67d3a46-096c-ed11-9560-000d3a69756c',
    WAITING_ON_INVESTIGATION_FI = '21adbfcd-bb51-f011-877b-000d3ab2abfa', // Odottaa selvitystä

    WAITING_ON_CUSTOMER = 'aac47252-096c-ed11-9560-000d3a69756c',
    WAITING_ON_CUSTOMER_FI = '757246c4-da87-f011-b4cb-7ced8d76ba58', // Odottaa ilmoittajan vastausta

    SHREDDED = '82c5556b-096c-ed11-9560-000d3a69756c',
    SHREDDED_NO = 'd631c220-bfc1-ed11-83ff-000d3adf6c88',
    SHREDDED_FI = '29adbfcd-bb51-f011-877b-000d3ab2abfa',

    CANCELLED_BY_CUSTOMER = 'd582b2ab-73b4-ee11-a569-000d3adf6c88',
    CANCELLED_BY_CUSTOMER_NO = 'aed5e29a-c2f0-ee11-904b-000d3ad985c2',
    CANCELLED_BY_CUSTOMER_FI = '7b7246c4-da87-f011-b4cb-7ced8d76ba58',

    SUBCONTRACTOR = '61d8b1d6-6c8c-ed11-81ad-000d3adf6077',
    SUBCONTRACTOR_NO_LOGIN = '333d227c-b141-ee11-bdf3-000d3adf6ed1', //'c230b05b-6d45-ee11-be6e-000d3adf60bc',
    SUBCONTRACTOR_NO_LOGIN_NO = '17b62400-6d45-ee11-be6e-0022489a0604',

    CUSTOMER_BOOKED = 'b71bb4c6-6c8c-ed11-81ad-000d3adf6077',
    CUSTOMER_NOT_BOOKED = 'bc2cb1cc-6c8c-ed11-81ad-000d3adf6077',
    MATERIALS = 'd72cb1cc-6c8c-ed11-81ad-000d3adf6077',
    INVESTIGATION = '5151bae2-6c8c-ed11-81ad-000d3adf6077',
    INFO_FROM_CUSTOMER = '4dab25eb-6c8c-ed11-81ad-000d3adf6077',
    OTHER_SEASON = '6e3f8da0-6c8c-ed11-81ad-000d3adf6077',

    REFERENCE = "c9a339b0-376c-ef11-bfe2-000d3add6761",
    REFERENCE_NO = "261311a2-5b85-ef11-ac21-6045bde0223d",
}

export enum CasetType {
    WARRANTY = 'Garanti',
    WARRANTY_FI = 'Tuotanto, takuu ja vastuu',
    MANAGEMENT = 'Förvaltning',
    MANAGEMENT_OTHER = 'Förvaltning övrig',
    ROUNDS_CASE = 'Rondering - Anmärkning',
    SERVICES = 'Tjänster',
    COMPLAINT = 'Reklamasjon',
    INSPECTION_REMARK = 'Befaring - Anmerkning',
    CUSTOMER_SERVICE = 'Kundservice',
    CUSTOMER_SERVICE_NO = 'Kundeservice',
    CUSTOMER_SERVICE_FI = 'Asiakaspalvelu',
    ONE_YEAR_INSPECTION = '1-vuotistarkastus',
    TWO_YEAR_INSPECTION = '2-vuotistarkastus',
}

/*
Objekt
Trapphus
Fastighet
 */

export enum BuildingType {
    OBJECT = 'Object',
    STAIRS = 'Stairs',
    PROPERTY = 'Property',
}

export enum RoomType {
    GENERAL = '899310013',
    WASTE = '899310014',
    BALCONY = '899310005',
    STORAGE = '899310012',
    GARAGE = '899310018',
    KITCHEN = '899310001',
    TECHNICAL_ROOM = '899310017',
    STAIRS = '899310015',
    LAUNDRY = '899310019',
    OUTDOOR_SPACE = '899310011',
    WET_ROOM = '899310016',
    OTHER = '899310010',
}

export enum AdressFields {
    ADRESS = 0,
    ZIP_CODE = 1,
    CITY = 2,
    GOVERNMENT_ID = 3,
}

export enum OtherContactFields {
    NAME = 0,
    EMAIL = 1,
    PHONE = 2
}
